
import { returnCheckList, stringContact, email } from './utilities-function';

export const PRIVACY_CHECK_LIST = [
    {
        id: 1,
        group_check_list: [
            {
                name: 'ข้อมูลบัญชีผู้ใช้งาน',
                description: 'เช่น',
                footer: '',
                index_start: 0,
                index_end: 6
            },
            {
                name: 'ข้อมูลการชำระเงิน',
                description: 'เราอาจเก็บข้อมูลที่เกี่ยวข้องกับการชำระเงิน เช่น',
                footer: 'เราไม่จำเป็นต้องจัดเก็บข้อมูลบัตรเครดิตทั้งหมดของลูกค้า หากการชำระเงินดำเนินการผ่านผู้ให้บริการรับชำระเงินภายนอก',
                index_start: 7,
                index_end: 11
            },
            {
                name: 'ข้อมูลการเรียน',
                description: 'เพื่อให้บริการคอร์สออนไลน์ เราอาจเก็บข้อมูล เช่น',
                footer: '',
                index_start: 12,
                index_end: 17
            },
            {
                name: 'ข้อมูลทางเทคนิค',
                description: 'เมื่อผู้ใช้งานเข้าชมเว็บไซต์ ระบบอาจเก็บข้อมูล เช่น',
                footer: 'ข้อมูลบางส่วนอาจได้รับผ่าน Cookies และเทคโนโลยีที่คล้ายคลึงกัน',
                index_start: 18,
                index_end: 24
            },
        ],
        check_list: [
            `<span>ชื่อ-นามสกุล</span>`,
            `<span>อีเมล</span>`,
            `<span>หมายเลขโทรศัพท์</span>`,
            `<span>ที่อยู่</span>`,
            `<span>ชื่อผู้ใช้งาน</span>`,
            `<span>รหัสผ่านที่ผ่านการเข้ารหัสหรือแฮช</span>`,
            `<span>รูปโปรไฟล์ (หากมี)</span>`,

            `<span>ช่องทางการชำระเงิน</span>`,
            `<span>จำนวนเงิน</span>`,
            `<span>เผยแพร่วันที่และเวลาการชำระเงินหรือแจกจ่ายต่อ</span>`,
            `<span>เลขอ้างอิงรายการชำระเงิน</span>`,
            `<span>สถานะการทำรายการ</span>`,


            `<span>คอร์สที่ลงทะเบียน</span>`,
            `<span>บทเรียนที่เรียน</span>`,
            `<span>ความคืบหน้าการเรียน</span>`,
            `<span>ผลการทดสอบ</span>`,
            `<span>คะแนน</span>`,
            `<span>วันที่และเวลาการเข้าเรียน</span>`,

            `<span>IP Address</span>`,
            `<span>ประเภทอุปกรณ์</span>`,
            `<span>ระบบปฏิบัติการ</span>`,
            `<span>ประเภทและเวอร์ชันของ Browser</span>`,
            `<span>วันที่และเวลาการใช้งาน</span>`,
            `<span>URL ที่เข้าชม</span>`,
            `<span>ข้อมูลเกี่ยวกับการใช้งานเว็บไซต์</span>`,
        ]
    },
    {
        id: 2,
        group_check_list: [
            {
                name: 'การให้บริการ',
                description: '',
                footer: '',
                index_start: 0,
                index_end: 4
            },
            {
                name: 'การดำเนินการเกี่ยวกับคำสั่งซื้อ',
                description: '',
                footer: '',
                index_start: 5,
                index_end: 9
            },
            {
                name: 'การรักษาความปลอดภัย',
                description: 'เราอาจใช้ข้อมูลเพื่อ',
                footer: '',
                index_start: 10,
                index_end: 14
            },
            {
                name: 'การปรับปรุงบริการ',
                description: 'เราอาจวิเคราะห์ข้อมูลการใช้งานเพื่อ',
                footer: '',
                index_start: 15,
                index_end: 18
            },
            {
                name: 'ข้อมูลทางเทคนิค',
                description: '',
                footer: '',
                index_start: 18,
                index_end: 24
            },
        ],
        check_list: [

            `<span>สร้างและจัดการบัญชี</span>`,
            `<span>ให้บริการคอร์สออนไลน์</span>`,
            `<span>บันทึกความคืบหน้าการเรียน</span>`,
            `<span>ให้บริการแบบทดสอบ</span>`,
            `<span>ให้บริการลูกค้า</span>`,

            `<span>ดำเนินการสั่งซื้อ</span>`,
            `<span>ตรวจสอบการชำระเงิน</span>`,
            `<span>ออกใบเสร็จหรือเอกสารที่เกี่ยวข้อง</span>`,
            `<span>จัดการการคืนเงิน</span>`,
            `<span>ตรวจสอบประวัติการทำรายการ</span>`,

            `<span>ตรวจสอบการเข้าสู่ระบบ</span>`,
            `<span>ป้องกันการเข้าถึงบัญชีโดยไม่ได้รับอนุญาต</span>`,
            `<span>ตรวจจับการใช้งานที่ผิดปกติ</span>`,
            `<span>ป้องกันการฉ้อโกง</span>`,
            `<span>ป้องกันการโจมตีระบบ</span>`,

            `<span>ปรับปรุงเว็บไซต์</span>`,
            `<span>ปรับปรุงระบบการเรียน</span>`,
            `<span>วิเคราะห์ประสิทธิภาพของคอร์ส</span>`,
            `<span>ปรับปรุงประสบการณ์ผู้ใช้งาน</span>`,

            `<span>การยืนยันคำสั่งซื้อ</span>`,
            `<span>แจ้งสถานะการชำระเงิน</span>`,
            `<span>แจ้งข้อมูลเกี่ยวกับบัญชี</span>`,
            `<span>แจ้งการเปลี่ยนแปลงบริการ</span>`,
            `<span>การแจ้งเตือนเกี่ยวกับคอร์ส</span>`,
            `<span>ข่าวสารหรือโปรโมชั่น <span class="fw-bold">เมื่อได้รับความยินยอมตามที่กฎหมายกำหนด</span></span>`,

        ]
    },
    {
        id: 3,
        check_list: [
            `<span>การปฏิบัติตามสัญญา</span>`,
            `<span>การปฏิบัติตามกฎหมาย</span>`,
            `<span>ประโยชน์โดยชอบด้วยกฎหมาย</span>`,
            `<span>ความยินยอมของเจ้าของข้อมูลส่วนบุคคล</span>`,
            `<span>ฐานทางกฎหมายอื่นที่กฎหมายกำหนด</span>`,
        ]
    },
    {
        id: 4,
        group_check_list: [
            {
                name: 'ผู้ให้บริการชำระเงิน',
                description: 'เพื่อดำเนินการและตรวจสอบการชำระเงิน',
                footer: '',
                index_start: 0,
                index_end: 0
            },
            {
                name: 'ผู้ให้บริการระบบ Cloud / Hosting',
                description: 'เพื่อจัดเก็บและประมวลผลข้อมูลของระบบ',
                footer: '',
                index_start: 0,
                index_end: 0
            },
            {
                name: 'ผู้ให้บริการระบบอีเมลหรือข้อความ',
                description: 'เพื่อส่งข้อมูลการสมัครสมาชิก การสั่งซื้อ และการแจ้งเตือน',
                footer: '',
                index_start: 0,
                index_end: 0
            },
            {
                name: 'ผู้ให้บริการวิเคราะห์ข้อมูล',
                description: 'เพื่อวิเคราะห์และปรับปรุงประสิทธิภาพของเว็บไซต์',
                footer: '',
                index_start: 0,
                index_end: 0
            },
            {
                name: 'ผู้สอนหรือเจ้าของคอร์ส',
                description: 'ในกรณีที่จำเป็นต่อการให้บริการคอร์ส เช่น การตรวจสอบผลการเรียนหรือการออก Certificate',
                footer: '',
                index_start: 0,
                index_end: 0
            },
            {
                name: 'หน่วยงานของรัฐ',
                description: 'ในกรณีที่กฎหมายกำหนดหรือมีคำสั่งตามกฎหมาย เราจะเปิดเผยข้อมูลเท่าที่จำเป็นและเหมาะสมกับวัตถุประสงค์นั้น ๆ',
                footer: '',
                index_start: 0,
                index_end: 0
            },
        ],
        check_list: []
    },
    {
        id: 5,
        check_list: []
    },
    {
        id: 6,
        check_list: [
            `<span>การเข้าถึงโดยไม่ได้รับอนุญาต</span>`,
            `<span>การสูญหาย</span>`,
            `<span>การเปลี่ยนแปลง</span>`,
            `<span>การเปิดเผย</span>`,
            `<span>การทำลาย</span>`,

            `<span>การเข้ารหัสข้อมูล</span>`,
            `<span>HTTPS</span>`,
            `<span>การควบคุมสิทธิ์การเข้าถึง</span>`,
            `<span>การ Authentication</span>`,
            `<span>การจัดเก็บรหัสผ่านในรูปแบบที่ปลอดภัย</span>`,
            `<span>การบันทึกและตรวจสอบกิจกรรมของระบบ</span>`,
        ]
    },
    {
        id: 7,
        check_list: []
    },
    {
        id: 8,
        check_list: [
            `<span>สิทธิในการเข้าถึงข้อมูลส่วนบุคคล</span>`,
            `<span>สิทธิในการขอรับสำเนาข้อมูล</span>`,
            `<span>สิทธิในการแก้ไขข้อมูลให้ถูกต้อง</span>`,
            `<span>สิทธิในการลบข้อมูล</span>`,
            `<span>สิทธิในการจำกัดการประมวลผล</span>`,
            `<span>สิทธิในการคัดค้านการประมวลผล</span>`,
            `<span>สิทธิในการถอนความยินยอม</span>`,
            `<span>สิทธิในการขอรับหรือโอนข้อมูล</span>`,
            `<span>สิทธิในการร้องเรียนต่อหน่วยงานที่เกี่ยวข้อง</span>`,
        ]
    },
    {
        id: 9,
        check_list: []
    },
    {
        id: 10,
        check_list: []
    },
    {
        id: 11,
        check_list: []
    },
    {
        id: 12,
        check_list: []
    },
    {
        id: 13,
        check_list: []
    },
]

export const PRIVACY_POLICIES = [
    {
        id: 1,
        name: 'ข้อมูลส่วนบุคคลที่เราเก็บรวบรวม',
        content: `
        <p class="mb-0">เราอาจเก็บรวบรวมข้อมูลส่วนบุคคลของลูกค้าในกรณีต่าง ๆ ดังต่อไปนี้</p>
        ${returnGroupList(1)}
        `
    },
    {
        id: 2,
        name: 'วัตถุประสงค์ในการเก็บและใช้ข้อมูล',
        content: `
        <p class="mb-0">เราอาจใช้ข้อมูลส่วนบุคคลเพื่อวัตถุประสงค์ดังต่อไปนี้</p>
        ${returnGroupList(2)}
        `
    },
    {
        id: 3,
        name: 'ฐานทางกฎหมายในการประมวลผลข้อมูล',
        content: `
        <p class="mb-0">ในการเก็บและใช้ข้อมูลส่วนบุคคล เราจะดำเนินการโดยอาศัยฐานทางกฎหมายที่เหมาะสม เช่น</p>
        ${returnCheckList({ file_data: PRIVACY_CHECK_LIST, check_list_id: 3 })}
        <p class="mb-0">ทั้งนี้ ฐานทางกฎหมายที่ใช้จะขึ้นอยู่กับวัตถุประสงค์ของการประมวลผลข้อมูลแต่ละประเภท</p>
        
        `
    },
    {
        id: 4,
        name: 'การเปิดเผยข้อมูลแก่บุคคลภายนอก',
        content: `
        <p class="mb-0">ผู้ใช้งานสามารถชำระค่าบริการผ่านช่องทางที่เว็บไซต์กำหนด เช่น</p>
            ${returnGroupList(4)}
        `
    },
    {
        id: 5,
        name: 'การโอนข้อมูลไปยังต่างประเทศ',
        content: `
        <p class="mb-0">ในบางกรณี ผู้ให้บริการหรือผู้ประมวลผลข้อมูลที่เราใช้งานอาจมีระบบหรือเซิร์ฟเวอร์ตั้งอยู่ในต่างประเทศ
<br/>หากมีการส่งหรือโอนข้อมูลส่วนบุคคลไปยังต่างประเทศ เราจะดำเนินการตามหลักเกณฑ์และเงื่อนไขที่กฎหมายคุ้มครองข้อมูลส่วนบุคคลกำหนด</p>
        `
    },
    {
        id: 6,
        name: 'การรักษาความปลอดภัยของข้อมูล',
        content: `
        <p class="mb-0">เราใช้มาตรการด้านเทคนิคและการบริหารจัดการที่เหมาะสมเพื่อป้องกันข้อมูลส่วนบุคคลจาก</p>
        ${returnCheckList({ file_data: PRIVACY_CHECK_LIST, check_list_id: 6, index_start: 0, index_end: 4 })}
        <p class="mb-0">ตัวอย่างมาตรการอาจรวมถึง</p>
        ${returnCheckList({ file_data: PRIVACY_CHECK_LIST, check_list_id: 6, index_start: 5, index_end: 10 })}
        <p class="mb-0">อย่างไรก็ตาม ไม่มีระบบใดสามารถรับประกันความปลอดภัยได้อย่างสมบูรณ์</p>
        `
    },
    {
        id: 7,
        name: 'ระยะเวลาการเก็บรักษาข้อมูล',
        content: `
        <p class="mb-0">
        เราจะเก็บรักษาข้อมูลส่วนบุคคลเท่าที่จำเป็นตามวัตถุประสงค์ที่แจ้งไว้ หรือเท่าที่จำเป็นเพื่อปฏิบัติตามกฎหมายและข้อกำหนดที่เกี่ยวข้อง
            <br/>
        เมื่อไม่มีความจำเป็นต้องเก็บข้อมูลแล้ว เราจะดำเนินการลบ ทำลาย หรือทำให้ข้อมูลไม่สามารถระบุตัวบุคคลได้ตามความเหมาะสม
        </p>
        `
    },
    {
        id: 8,
        name: 'สิทธิของเจ้าของข้อมูลส่วนบุคคล',
        content: `
        <p class="mb-0">ภายใต้เงื่อนไขและข้อยกเว้นตามกฎหมาย ลูกค้าอาจมีสิทธิ เช่น</p>
        ${returnCheckList({ file_data: PRIVACY_CHECK_LIST, check_list_id: 8 })}
        <p class="mb-0">การใช้สิทธิอาจอยู่ภายใต้เงื่อนไขและข้อจำกัดตามที่กฎหมายกำหนด</p>
        `
    },
    {
        id: 9,
        name: 'การถอนความยินยอม',
        content: `
      <p class="mb-0">
        ในกรณีที่เราเก็บหรือใช้ข้อมูลโดยอาศัยความยินยอม ลูกค้าสามารถถอนความยินยอมได้ตลอดเวลา 
        อย่างไรก็ตาม การถอนความยินยอมจะไม่กระทบต่อการประมวลผลข้อมูลที่ได้ดำเนินการไปแล้วก่อนการถอนความยินยอม 
        นอกจากนี้ การถอนความยินยอมบางประเภทอาจทำให้เราไม่สามารถให้บริการบางอย่างแก่ลูกค้าได้
      </p>

    
        `
    },
    {
        id: 10,
        name: 'ข้อมูลของผู้เยาว์',
        content: `
        <p class="mb-0">
            บริการบางประเภทอาจมีข้อกำหนดเกี่ยวกับอายุของผู้ใช้งาน
            หากการให้บริการเกี่ยวข้องกับผู้เยาว์ เราจะดำเนินการเกี่ยวกับการเก็บ ใช้ หรือเปิดเผยข้อมูลตามกฎหมายที่เกี่ยวข้อง และอาจขอความยินยอมจากผู้ปกครองหรือผู้มีอำนาจตามกฎหมายในกรณีที่จำเป็น
        </p>
        `
    },
    {
        id: 11,
        name: 'การใช้คุกกี้',
        content: `
        <p class="mb-0">
        เว็บไซต์ใช้ Cookies และเทคโนโลยีที่เกี่ยวข้องเพื่อให้บริการและปรับปรุงประสบการณ์ของผู้ใช้งาน
        รายละเอียดเกี่ยวกับการใช้ Cookies สามารถดูได้จาก <br/>
        <a class="fw-bold text-primary cursor-pointer text-hover-underline" href="/cookies-policy">นโยบายการใช้คุกกี้ (Cookie Policy)</a>
        </p>
        `
    },
    {
        id: 12,
        name: 'การเปลี่ยนแปลงนโยบายความเป็นส่วนตัว',
        content: `
        <p class="mb-0">
        เราอาจปรับปรุงนโยบายความเป็นส่วนตัวเป็นครั้งคราว เพื่อให้สอดคล้องกับการเปลี่ยนแปลงของบริการ เทคโนโลยี หรือกฎหมายที่เกี่ยวข้อง
        หากมีการเปลี่ยนแปลงที่มีนัยสำคัญ เราอาจแจ้งให้ลูกค้าทราบผ่านช่องทางที่เหมาะสม
        </p>
        `
    },

    {
        id: 13,
        name: 'ติดต่อเกี่ยวกับข้อมูลส่วนบุคคล',
        content: `หากลูกค้าต้องการใช้สิทธิหรือมีคำถามเกี่ยวกับนโยบายความเป็นส่วนตัว สามารถติดต่อได้ที่<br/>
    <p class="mb-0 mt-2 fw-bold">ผู้ควบคุมข้อมูลส่วนบุคคล (Data Controller)</p>
    ${stringContact()}
    <p class="mb-0 mt-2 fw-bold">เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล (DPO)</p>
    <p class="mb-0">อีเมล: ${email}</p
    `
    },


]

export function returnGroupList(check_list_id: number, bullet: 'dot' | 'number' = 'dot'): string {
    const group_check_list = PRIVACY_CHECK_LIST?.find(item => item.id === check_list_id)!.group_check_list || []
    let innerHtml = group_check_list ? `${group_check_list.map((item) => `
        <p class="mb-0 mt-2 fw-bold text-gray-800">${item.name}</p>
        <p class="mb-0 ">${item.description}</p>
        ${returnCheckList({ file_data: PRIVACY_CHECK_LIST, check_list_id: check_list_id, index_start: item.index_start, index_end: item.index_end })}
        <p class="mb-0 ">${item.footer}</p>`).join('')} ` : ''
    return innerHtml
}



